export default {
    "landing.nav.pricing": "Tarifs",
    "landing.nav.login": "Connexion",
    "landing.nav.start": "Commencer maintenant",

    "landing.hero.badge": "L'outil n°1 pour votre citoyenneté",
    "landing.promo.badge": "💝 Spécial Mois de l'Amour : -30% avec le code LOVE30",
    "landing.hero.title": "Réussissez votre examen de citoyenneté du premier coup",
    "landing.hero.title_gradient": "du premier coup",
    "landing.hero.description": "Maîtrisez le guide officiel grâce à nos quiz adaptatifs, flashcards intelligentes et résumés audio. La méthode la plus efficace pour devenir Canadien.",
    "landing.hero.cta.free": "Essayer gratuitement",
    "landing.hero.cta.install": "Installer l'app",
    "landing.hero.cta.discover": "Découvrir CitoyenPro",

    "landing.stats.questions": "Questions réelles",
    "landing.stats.success": "Taux de réussite",
    "landing.stats.audio": "Résumés audio",
    "landing.stats.access": "Accès illimité",

    "landing.features.title": "Tout ce dont vous avez besoin pour réussir",
    "landing.features.description": "Une suite complète d'outils d'apprentissage conçue pour vous faire gagner du temps et maximiser votre mémorisation.",

    "landing.features.flashcards.title": "Flashcards Intelligentes",
    "landing.features.flashcards.desc": "Utilisez la répétition espacée pour mémoriser les dates et faits historiques sans effort.",
    "landing.features.quiz.title": "Quiz par Thématique",
    "landing.features.quiz.desc": "Pratiquez chapitre par chapitre et identifiez instantanément vos points faibles.",
    "landing.features.audio.title": "Résumés Audio",
    "landing.features.audio.desc": "Écoutez l'essentiel du guide pendant vos trajets ou vos activités quotidiennes.",
    "landing.features.exam.title": "Examens Blancs",
    "landing.features.exam.desc": "Simulez les conditions réelles avec un chronomètre et 20 questions aléatoires.",
    "landing.features.stats.title": "Suivi de Progression",
    "landing.features.stats.desc": "Visualisez votre évolution avec des graphiques détaillés sur votre précision.",
    "landing.features.gamification.title": "Défis & Badges",
    "landing.features.gamification.desc": "Restez motivé en débloquant des succès et en maintenant votre série quotidienne.",

    "landing.gamification.badge": "Apprentissage Ludique",
    "landing.gamification.title": "Apprenez en vous amusant",
    "landing.gamification.description": "CitoyenPro transforme la révision en une expérience engageante. Relevez des défis, gagnez des badges et rejoignez des milliers de futurs citoyens motivés.",
    "landing.gamification.item1.title": "Badges de Succès",
    "landing.gamification.item1.desc": "Collectionnez des badges uniques en complétant des thèmes et en réussissant des quiz parfaits.",
    "landing.gamification.item2.title": "Série de Connexion",
    "landing.gamification.item2.desc": "Maintenez votre rythme d'étude quotidien pour renforcer votre mémorisation à long terme.",
    "landing.gamification.item3.title": "Tableau de Bord",
    "landing.gamification.item3.desc": "Suivez votre score global et voyez comment vous vous préparez pour le grand jour.",
    "landing.gamification.mockup.streak": "Série de 7 jours",
    "landing.gamification.mockup.scan": "Scanner pour installer",

    "landing.testimonials.title": "Ils sont devenus Canadiens avec nous",
    "landing.testimonials.description": "Découvrez les témoignages de ceux qui ont réussi leur examen grâce à la méthode CitoyenPro.",
    "landing.testimonials.item1.name": "Maria Silva",
    "landing.testimonials.item1.role": "Nouvelle Citoyenne (Toronto)",
    "landing.testimonials.item1.quote": "Les résumés audio ont tout changé ! J'ai pu réviser dans le métro chaque matin. Résultat : 20/20 à l'examen.",
    "landing.testimonials.item2.name": "Ahmed Mansour",
    "landing.testimonials.item2.role": "Futur Citoyen (Montréal)",
    "landing.testimonials.item2.quote": "Les quiz sont très proches des questions réelles. Ça m'a donné une confiance incroyable pour le jour J.",
    "landing.testimonials.item3.name": "Li Wei Tan",
    "landing.testimonials.item3.role": "Nouvelle Citoyenne (Vancouver)",
    "landing.testimonials.item3.quote": "L'interface est super intuitive. On voit vraiment sa progression évoluer, c'est très motivant.",

    "landing.cta.title": "Votre parcours vers la citoyenneté commence ici",
    "landing.cta.description": "Rejoignez CitoyenPro aujourd'hui et donnez-vous toutes les chances de réussir votre intégration au Canada.",
    "landing.cta.free": "Démarrer gratuitement",
    "landing.cta.pricing": "Consulter les tarifs",

    "landing.pwa.badge": "Application Mobile",
    "landing.pwa.title": "CitoyenPro sur votre téléphone",
    "landing.pwa.description": "Installez CitoyenPro instantanément sur votre écran d'accueil sans passer par les stores. Accès rapide, fluide et efficace.",
    "landing.pwa.step1.title": "Ouvrez le menu",
    "landing.pwa.step1.desc": "Appuyez sur 'Partager' sur iOS ou le menu de Chrome sur Android.",
    "landing.pwa.step2.title": "Ajouter à l'écran",
    "landing.pwa.step2.desc": "Sélectionnez 'Sur l'écran d'accueil' pour installer l'application.",
    "landing.pwa.direct": "Installation Directe",
    "landing.pwa.fast": "Pas besoin d'App Store",

    "landing.footer.description": "La plateforme de référence pour préparer votre examen de citoyenneté canadienne avec succès.",
    "landing.footer.social": "Suivez-nous",
    "landing.footer.product": "Produit",
    "landing.footer.product.features": "Fonctionnalités",
    "landing.footer.resources": "Ressources",
    "landing.footer.resources.guide": "Guide d'étude",
    "landing.footer.resources.help": "Aide & Support",
    "landing.footer.resources.news": "Nouveautés",
    "landing.footer.resources.contact": "Contact",
    "landing.footer.legal": "Légal",
    "landing.footer.legal.privacy": "Confidentialité",
    "landing.footer.legal.terms": "Conditions",
    "landing.footer.legal.notices": "Mentions Légales",
    "landing.footer.copyright": "© 2025 CitoyenPro. Tous droits réservés."
};
